import * as React from 'react';
export const aplazameSvg = React.forwardRef(function aplazameSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.073 1 16 15h-3.13l-.866-3.226H6.222L5.357 15H2.226l.905-3.225H0l.662-2.36h10.707L9.113 1h2.96Zm-2.96 0L7.14 8.35H4.09L6.153 1h2.96Z',
    }),
  );
});
aplazameSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var aplazame = {
  category: 'paymentmethod',
  colorable: true,
  name: 'aplazame',
  svg: aplazameSvg,
};
